module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1ZhE3"))).then(() => parcelRequire('hEqeo'));